import { WidgetEnv } from "@xapp/stentor-chat-widget";
import React, { FC, useMemo } from "react";
import { Provider } from "react-redux";
import { ChatWidgetProps } from ".";
import { useServerConfig } from "../../config";
import { MessageMiddleware, useStandardMiddleware } from "../../middlewares";
import { CONNECTION_STATUS_TYPE } from "../../store/ChatAction";
import { createChatStore } from "../../store/ChatStore";
import ChatWidget, { ChatWidgetMode } from "./ChatWidget";

export interface ChatWidgetContainerProps {
    readonly preChatFormEnabled?: boolean;
    readonly mode?: ChatWidgetMode;
    readonly config?: WidgetEnv;
    onConnectionStatusChange?(status: CONNECTION_STATUS_TYPE): void;
}

const ChatWidgetContainer: FC<ChatWidgetContainerProps> = props => {

    const messageMiddleware: MessageMiddleware = useStandardMiddleware();

    const connection = useServerConfig(props.config);

    const chatStore = useMemo(() => createChatStore({
        connection,
        userId: props.config?.userId,
        accessToken: props.config?.accessToken,
        attributes: props.config?.attributes,
        sessionExpiration: props.config?.sessionExpiration
    }), [connection, props.config?.userId, props.config?.accessToken, props.config?.attributes, props.config?.sessionExpiration]);

    if (props.config?.disabled) {
        return <></>;
    }

    const widgetProps: ChatWidgetProps = {
        ...props,
        messageMiddleware
    }

    return (
        <Provider store={chatStore}>
            <ChatWidget
                {...widgetProps}
            />
        </Provider>
    );
}

export default ChatWidgetContainer;